<template>
  <GmapMap
    :center="center"
    :zoom="zoom"
    :options="mapStyle"
    class="cust-preonboarding-map"
  >
    <!-- <gmap-info-window
      :options="infoOptions"
      :position="infoWindowPos"
      :opened="infoWinOpen"
      @closeclick="infoWinOpen = false"
    >
    </gmap-info-window> -->

    <!-- <GmapMarker
      :key="index"
      v-for="(m, index) in markers"
      :position="m.position"
      :clickable="true"
      :draggable="false"
      :icon="{ url: require('@/../public/favicon.png') }"
      @mouseover="toggleInfoWindow(m, index)"
      @click="markerClicked(m)"
    /> -->
  </GmapMap>
</template>

<script>
import mapStyle from "./mapStyle";
import { gmapApi } from "vue2-google-maps";
import { mapState } from "vuex";

export default {
  data() {
    return {
      center: { lat: 19.071549, lng: 72.8527913 }, //Default Location
      zoom: 13, // Default Zoom
      mapStyle: mapStyle,
      // infoWindowPos: null,
      // infoWinOpen: false,
      // currentMidx: null,
      // infoOptions: {
      //   content: "",
      //   //optional: offset infowindow so it visually sits nicely on top of our marker
      //   pixelOffset: {
      //     width: 0,
      //     height: -35,
      //   },
      // },
    };
  },
  mounted() {
    // this.$store.dispatch("turf/fetchTurfMarkers");
    // this.focusOnFirstTurf();
    this.init();
  },
  computed: {
    google: gmapApi,
    // ...mapGetters("turf", {
    //   turfMarkers: "turfMarkers",
    //   turfs: "turfs",
    // }),
    ...mapState("respitecare", {
      get_location: "get_location",
    }),
    ...mapState("respitecare", {
      get_location_by_name: "get_location_by_name",
    }),
    // markers() {
    //   return this.turfMarkers && this.turfMarkers.length
    //     ? this.turfMarkers.map((element) => ({
    //         id: element.id,
    //         position:
    //           this.google &&
    //           new this.google.maps.LatLng(
    //             Number(element.position.split(",")[0]),
    //             Number(element.position.split(",")[1])
    //           ),
    //         infoText: element.name,
    //       }))
    //     : [];
    // },
    // isLoggedIn() {
    //   return this.$store.state.user && this.$store.state.user.userID != null;
    // },
  },
  methods: {
    async getLocationCoord() {
      try {
        await this.$store.dispatch("respitecare/get_location_by_name", {
          locationName: this.get_location.toLowerCase(),
        });
        this.center = {
          lat: parseFloat(this.get_location_by_name.locationLat),
          lng: parseFloat(this.get_location_by_name.locationLng),
        };
        this.zoom = this.get_location_by_name.zoom;
      } catch (error) {
        console.log(error);
      }
    },
    async init() {
      await this.getLocationCoord();
    },

    // toggleInfoWindow(marker, idx) {
    //   this.infoWindowPos = marker.position;
    //   this.infoOptions.content = marker.infoText;
    //   //check if its the same marker that was selected if yes toggle
    //   if (this.currentMidx == idx) {
    //     this.infoWinOpen = !this.infoWinOpen;
    //   }
    //   //if different marker set infowindow to open and reset current marker index
    //   else {
    //     this.infoWinOpen = true;
    //     this.currentMidx = idx;
    //   }
    // },
    // focusOnFirstTurf() {
    //   if (!this.turfs.length) return;
    //   //Get Turf Positions from result
    //   const turfPositions = this.turfs
    //     .map((x) => x.turf_position)
    //     .filter((x) => x != null);
    //   if (turfPositions && turfPositions.length) {
    //     //Get lat and long from first valid result
    //     const firstTurfPostition = turfPositions[0].split(",");
    //     //Center and zoom on first valid turf locations
    //     this.center = {
    //       lat: Number(firstTurfPostition[0]),
    //       lng: Number(firstTurfPostition[1]),
    //     };
    //     this.zoom = 13;
    //   }
    // },
    // markerClicked(marker) {
    //   if (!this.isLoggedIn) return;
    //   this.$store.commit("turf/SET_SELECTED_TURF_FROM_MARKER", marker.id);
    //   this.$router
    //     .push(`/pages/turf/${marker.id}/${marker.infoText}`)
    //     .catch(() => {});
    // },
  },
};
</script>

<style scoped>
.cust-preonboarding-map {
  width: 100%;
  height: 550px;
  min-height: 90vh;
}
@media (min-width: 768px) {
  .cust-preonboarding-map {
    height: 250px !important;
    min-height: 100% !important;
  }
}
</style>
